import request from '@/utils/request'
import base from "@/api/base";

export default {
    //查询面料类别
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/front/product/getFabricCategoryList/${params}`),
    // 新增面料类别
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/saveFabricCategory`, params),
    // 修改面料类别
    updata: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/updateFabricCategory`, params),
    // 删除面料类别
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/deleteFabricCategory`, params),

    //查询产品资料
    gets: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/front/product/getBaseProductList`, { params }),
    // 新增产品资料
    adds: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/saveBaseProduct`, params),
    // 修改产品资料
    updatas: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/updateBaseProduct`, params),
    // 删除产品资料
    dels: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/deleteBaseProduct`, params),

    //新增子账号
    addSubMember: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/addSubMember`, params),
    //查询子账号
    getSubMemberList: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/getSubMemberList`, params),
    //修改子账号
    updateSubMember: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/updateSubMember`, params),
    //删除子账号
    deleteSubMember: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/deleteSubMember`, params),

    //查询销售人员二维码列表
    getSalesPersonList: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/salesPerson/getSalesPersonList`, params),
    //新增销售人员
    addSalesPerson: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/salesPerson/saveSalesPerson`, params),
    //修改销售人员
    updateSalesPerson: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/salesPerson/updateSalesPerson`, params),
}